import { createGlobalStyle } from 'styled-components'
import sfMonoRegular from '../../assets/fonts/SFMono-Regular.woff2'
import interRegular from '../../assets/fonts/Inter-Regular.woff2'
import interMedium from '../../assets/fonts/Inter-Medium.woff2'
import interBold from '../../assets/fonts/Inter-Bold.woff2'
import sohneMonoKraftig from '../../assets/fonts/SohneMono-Kraftig.woff'

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'SFMono';
    src: url(${sfMonoRegular}) format('truetype');
    font-style: 400;
    font-display: swap;
  }

  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    src: url(${interRegular}) format('woff2');
  }

  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    src: url(${interMedium}) format('woff2');
  }

  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 700;
    src: url(${interBold}) format('woff2');
  }

  @font-face {
    font-family: 'SohneMono';
    font-style: normal;
    font-weight: normal;
    src: url(${sohneMonoKraftig}) format('woff');
  }

  html, body, #root {
    height: 100%;
    scroll-behavior: smooth;
  }

  body {
    margin: 0;
    font-family: 'Inter';
    font-weight: normal;
    color: #101123;
  }

  a,p,label,code,li {
    font-size: 14px;
    line-height: 22px;
  }

  h1,h2,h3,h4,h5,h6 {
    margin: 0;
  }

  div {
    p:last-of-type {
      margin-bottom: 0;
    }
  }

  h4 {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 12px;
  }

  p {
    font-weight: 400;
    margin-top: 0;
    margin-bottom: 12px;
  }

  a {
    font-weight: 500;
    text-decoration: none;
    color: #1A2F77;
    transition: 0.22s;

    &:hover {
      text-decoration: underline;
    }
  }

  code, .code-block {
    font-family: 'SFMono';
    font-weight: 400;
    color: #1A1B22;
    background-color: #E9F0F3;
    border-radius: 6px;
    padding: 5px;
    word-break: break-word;
    white-space: pre-wrap;
  }

  .code-block code {
    padding: 0;
  }

  label {
    font-weight: 700;
  }

  .__react_component_tooltip {
    background: #FFFFFF !important;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.2) !important;
    border-radius: 8px !important;
    padding: 12px !important;
    font-family: 'Inter' !important;
    font-weight: 600 !important;
    font-size: 14px !important;
    line-height: 20px !important;
    color: #101123 !important;
    max-width: 300px !important;
    word-break: break-word;

    &:before, &:after {
      display: none;
    }
  }

  ul, ol {
    word-break: break-word;
    padding-inline-start: 25px;
    margin-block: auto;
  }

 span {
    ul {
      padding-inline-start: 50px;
    }
 }
 
 .code-block {
    word-break: break-word;
    white-space: pre-wrap;
    padding: 24px;
    margin: 3px 0 0;
  }

  .coverage-table-container {
    overflow-x: auto;

    table {
      word-wrap: break-word;
      border-collapse: separate;
      border-spacing: 0;
      table-layout: fixed;
      background: #ffffff;
      border: 1px solid #e2e8f0;
      box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.05);
      border-radius: 12px;
      padding: 12px;
      font-family: 'Inter';
      color: #2d3748;
  
      thead {
        font-size: 12px;
        line-height: 16px;
      }
  
      tbody {
        font-size: 14px;
        line-height: 20px;
      }
  
      th {
        text-align: left;
        padding: 12px 24px;
        width: 100px;

        &:first-child {
          width: 200px;
        }
      }

      tr {
        background-color: #fcfcfc;

        &:nth-child(2n + 1) {
          background: #ffffff;
        }
      }

      td {
        border-top: 1px solid #e5e5e5;
        padding: 16px 24px;
        max-width: 80px;

        span {
          font-weight: 600;
        }
      }
    }

    @media screen and (max-width: 980px) {
      width: 100%;

      table {
        width: 100%;
      }
    }
  }
`

export default GlobalStyle
